// eslint-disable-next-line linebreak-style
import bootbox from 'bootbox';
import { withCookies } from 'react-cookie';
import config from '../config.js';
import axios from 'axios';
import Busy from 'busy-wait-cursor';
import { isEmpty } from 'lodash';
// import { translateText } from '../common/translate_text';
import $$ from 'jquery';
import { getValue } from '../common/data_storage';

const myApi = axios.create();

/*
  Keeps the real error text in the popup and adds the context needed to act on it - which
  endpoint was called and the HTTP status, when there is one. A bare
  "TypeError: Cannot read properties of undefined (reading '0')" is not enough to tell whether
  the network, the server or the payload was at fault.
*/
const describeError = (error, url) => {
  if (typeof error === 'string') return error; // caller supplied its own text, e.g. 'File not found.'
  const { response, config: requestConfig } = error || {};
  const parts = [`${error}`];
  if (response?.status) {
    parts.push(`HTTP ${response.status}${response.statusText ? ` ${response.statusText}` : ''}`);
  }
  const endpoint = url || requestConfig?.url;
  if (endpoint) parts.push(`Request: ${endpoint}`);
  return parts.join('\n');
};

export const ApiWebMessage = async (props) => {
  const { webMessage, Program, translateText, rspText, isErrorMessage, isKIOSKmode } = props;
  // Error paths can reach here without a context, so neither is guaranteed. Falling over inside
  // the code that reports the problem would leave the user with no message at all.
  const t = typeof translateText === 'function' ? translateText : (text) => text;
  const webMessageText = typeof webMessage === 'string' ? webMessage : String(webMessage ?? '');
  let message = '';
  if (webMessageText.indexOf('*') !== -1 && isErrorMessage) {
    let messageList = '';
    webMessageText.split('*').map((item, index) => {
      if (index > 0 && item.trim()) {
        messageList += `<li>*${t(item)}</li>`;
      }
    });
    message = `<div class='d-flex flex-column w-100 fontSize18 fontWeight500 justify-content-center align-items-start '>
      <ul style='list-style:none'>${messageList}</ul></div>`;
  }
  const webMessageContent = webMessageText.replaceAll('\n', '<br/>');
  bootbox.confirm({
    title: message && isErrorMessage ? t('The following errors have occurred:') :
      getValue('LangCode') === 'EN' || !getValue('LangCode') ? `Message` : `Mensaje`, //`${await translateText(`Message`)}`,
    message: message && isErrorMessage ? message : t(`${webMessageContent}`),
    buttons: {
      cancel: {
        label: t('OK'),
        className: 'btn primary_button w-unset',
      },
      confirm: {
        label: t('OK'),
        className: 'btn primary_button w-unset d-none',
      },
    },
    callback: (result) => {
      if (result || !result) {
        if (Program === 'Login' && !isKIOSKmode) {
          logOutWhenNoData();
        }
        if (rspText && Program === 'GWSymmetryFlow') {
          (async () => {
            bootbox.confirm({
              title: `${t(`Message`)}`,
              message: `<div class='d-inline-table w-100 text-break fontWeight500
              justify-content-center align-items-center'>
              <ul style='list-style:disc'>${rspText}</ul></div>`,
              buttons: {
                cancel: {
                  label: t('OK'),
                  className: 'btn primary_button w-unset',
                },
                confirm: {
                  label: t('OK'),
                  className: 'btn primary_button w-unset d-none',
                },
              },
              callback: () => { },
            });
          })();
        }
        else {
          window.scrollTo(0, 0);
          //return false;
        }
      }
    },
  });
};

/*
  The API can emit invalid JSON when a field comes back null - "key": , or "key": } - and
  axios 0.21 silently hands back the raw string when its own JSON.parse fails
  (transformResponse -> silentJSONParsing). So anything still a string here is a body that
  failed to parse: repair it and retry. An object has already parsed successfully and is
  returned untouched - re-stringifying it would run these regexes over legitimate string
  values as well as over the structure.
*/
const sanitizeJson = (raw) => {
  if (!raw || typeof raw !== 'string') return { data: raw };
  try {
    return { data: JSON.parse(raw) };
  }
  catch (parseError) {
    try {
      return {
        data: JSON.parse(
          raw
            .replace(/:\s*,/g, ': null,') // Fixes "key": ,
            .replace(/:\s*}/g, ': null}') // Fixes "key": } at end of object
            .replace(/\[\s*,/g, '[') // Fixes [ , 1, 2]
            .replace(/,\s*([\]}])/g, '$1'), // Fixes trailing commas [1, 2, ]
        ),
        repaired: true,
      };
    }
    catch (repairError) {
      return { data: raw, parseError: repairError };
    }
  }
};

const handleResponse = (props) => {
  const { response, callback, cookies, setStateData, history, context, noHourGlass } = props;
  const { dispatch, storeStateContext, loaderName, handleClose, translateText } = context || {};
  const url = response?.config?.url;

  const { data: sanitizedData, parseError, repaired } = sanitizeJson(response?.data);
  const responseMessage = sanitizedData?.response_message;
  const data = sanitizedData?.response_data?.[0];

  /*
    Every caller reads response_data[0] straight off the payload, so a body that is missing or
    malformed used to surface as an unrelated "Cannot read properties of undefined (reading '0')"
    from whichever component happened to touch it first. Report what is actually wrong, and log
    the whole body so support can see what the server sent.
  */
  const reportBadResponse = (detail) => {
    console.error(`[ESS] Bad response from ${url || 'the server'}:`, detail, response?.data);
    ApiWebMessage({
      webMessage: `${detail}\nRequest: ${url || 'unknown'}\nThe full response is in the browser console.`,
      translateText,
    });
  };

  if (parseError) {
    reportBadResponse(`The server returned a response that is not valid JSON: ${parseError.message}`);
  }
  else if (responseMessage !== 'Success') {
    reportBadResponse(`The server did not return Success. response_message: ${JSON.stringify(responseMessage) || 'missing'}`);
  }
  else if (sanitizedData?.response_data == null) {
    reportBadResponse('The server returned Success but the response contained no response_data.');
  }
  else if (data && (data.WebMessage || data.ErrorMessage)) {
    const { rspText = false, spfValid, isKIOSKmode } = data;
    const webMessageData = {
      webMessage: data.WebMessage || data.ErrorMessage,
      Program: data.Program,
      cookies,
      setStateData,
      history,
      translateText: translateText,
      isErrorMessage: !!data.ErrorMessage,
      // Both were dropped in the rewrite: without isKIOSKmode a kiosk login is logged straight
      // back out, and without rspText the GWSymmetryFlow follow-up popup can never open.
      isKIOSKmode: !!isKIOSKmode,
      rspText: (spfValid === 'no' && rspText) || false,
    };

    if (data.Program === 'Login' && !isKIOSKmode) {
      ApiWebMessage?.({ ...webMessageData });
    }
    else {
      ApiWebMessage?.({ ...webMessageData });
      callback?.({ ...sanitizedData });
    }
  }
  else {
    callback?.({ ...sanitizedData });
  }

  if (repaired) {
    console.warn(`[ESS] Malformed JSON from ${url || 'the server'} was repaired before use.`);
  }

  if (!noHourGlass) document.body.style.cursor = 'default';

  if (loaderName && dispatch) {
    dispatch({ 
      type: 'ADD_DATA', 
      payload: { 
        name: 'buttonLoader', 
        data: { ...storeStateContext, [loaderName]: false } 
      } 
    });
  } else if (handleClose) {
    handleClose();
  }
};

const handleCatchError = (error, context, url) => {
  const { dispatch, storeStateContext, loaderName, handleClose, translateText } = context || {};
  // Also log it: the popup gets dismissed, the console record does not.
  console.error(`[ESS] Request to ${url || 'the server'} failed:`, error);
  /*
    Built fresh each time. This used to reuse a module-level object that getDoc also wrote
    Program into, so an unrelated later failure could inherit Program === 'Login' and drop the
    user out of their session.
  */
  ApiWebMessage({
    webMessage: describeError(error, url),
    translateText,
  });
  $$('*').css('cursor', '');
  if (loaderName && dispatch) {
    dispatch({ type: 'ADD_DATA', payload: { name: 'buttonLoader', data: {
      ...storeStateContext, [loaderName]: false,
    } } });
  }
  else if (handleClose) {
    handleClose();
  }
};

const getPayloadData = ({ obj, call, /* history, */ data, translateText }) => {
  const { state, publicIp: remote_addr, custnum, empid, eida, eidb, kidb, kida } = obj || {};
  const { SessionID, bida, bidb, mfaCookieID } = state || {},
        { userAgent: http_user_agent } = navigator,
        { protocol: https, hostname } = window.location;
  if (isEmpty(state) && call !== 'get') {
    bootbox.confirm({
      title: !getValue('LangCode') ? `Message` : `Mensaje`, //`${await translateText(`Message`)}`,
      message: translateText(`Your session is no longer valid.  Please login again.`),
      buttons: {
        cancel: {
          label: translateText('OK'),
          className: 'btn primary_button',
        },
        confirm: {
          label: translateText('OK'),
          className: 'btn primary_button w-unset d-none',
        },
      },
      callback: (result) => {
        if (result || !result) {
          logOutWhenNoData();
        }
      },
    });
  }
  return {
    bidb,
    bida,
    eida,
    eidb,
    kidb,
    kida,
    mfaCookieID,
    custnum,
    empid,
    http_user_agent,
    https: https === 'http:' ? 'off' : 'on',
    hostname,
    remote_addr,
    session: SessionID || '',
    ...data || {},
  };
};

const logOutWhenNoData = (/* history */) => {
  localStorage.clear();
  sessionStorage.clear();
  if (document?.cookie) {
    document.cookie.split(';').forEach(function(c) {
      if (c.indexOf('eidb') > -1 || c.indexOf('eida') > -1 || c.indexOf('mfaCookieID') > -1 ||
        c.indexOf('kidb') > -1 || c.indexOf('kida') > -1) return;
      document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
  }
  const urlElements = window.location.href.split('/');
  if (urlElements.includes('login')) {
    return;
  }
  else {
    window.location.reload();
  }

  return;
};

const token = Buffer.from(`${config.USERNAME}:${config.PASSWORD}`, 'utf8').toString('base64');

const apiCall = async ({ obj, payload, callback, cookies, setStateData, history, noHourGlass }) => {
  !noHourGlass && $$(':root').css('cursor', 'wait');
  await new Promise(resolve => {
    setTimeout(function() {
      resolve((async () => {
        await myApi
          .post(obj.url, payload)
          .then(response => handleResponse({ response, callback, cookies, setStateData, history, context: obj.context, noHourGlass }))
          .catch(error => handleCatchError(error, obj.context, obj.url));
      })(),
      );
    }, 200);
  });
};

const APICallManager = {
  getCall: (obj, data, callback) => {
    if (token) {
      myApi.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
    const { history, translateText, dispatch, loaderName, storeStateContext, handleOpen } = obj.context || {},
          payload = getPayloadData({ obj: obj.context, call: 'get', history, data, translateText });
    loaderName ? dispatch({ type: 'ADD_DATA', payload: { name: 'buttonLoader', data: {
      ...storeStateContext, [loaderName]: true,
    } } }) : handleOpen();
    (async () => {
      await Busy.wait();
      await apiCall({ obj, payload, callback, history });
      Busy.done();
    })()
      .catch(() => {});
  },
  postCall: (obj, data, callback) => {
    if (token) {
      myApi.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
    const { setStateData, cookies, history, translateText, dispatch, loaderName, storeStateContext, handleOpen } = obj.context || {},
          payload = getPayloadData({ obj: obj.context, call: 'post', history, data, translateText }),
          disableMouse = true;
    loaderName ? dispatch({ type: 'ADD_DATA', payload: { name: 'buttonLoader', data: {
      ...storeStateContext, [loaderName]: true,
    } } }) : handleOpen();
    (async () => {
      //await Busy.wait();
      $$(':root').css('pointer-events', 'none');
      await apiCall({ obj, payload, callback, cookies, setStateData, history, disableMouse });
      //Busy.done();
      $$('*').css('pointer-events', '');
    })()
      .catch(() => {});
  },
  postRaw: (obj, data, callback) => {
    if (token) {
      myApi.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
    const { dispatch, loaderName, storeStateContext, handleOpen, handleClose } = obj.context || {};
    const payload = getPayloadData({ obj: obj.context, call: 'post', data });

    loaderName ? dispatch({ type: 'ADD_DATA', payload: { name: 'buttonLoader', data: { ...storeStateContext, [loaderName]: true } } }) : handleOpen();

    (async () => {
      try {
        $$(':root').css('cursor', 'wait');
        const response = await myApi.post(obj.url, payload);
        
        // BYPASS: We call the callback directly with the data, skipping handleResponse
        callback(response); 
        
        $$('*').css('cursor', '');
        loaderName ? dispatch({ type: 'ADD_DATA', payload: { name: 'buttonLoader', data: { ...storeStateContext, [loaderName]: false } } }) : handleClose();
      } catch (error) {
        handleCatchError(error, obj.context, obj.url);
      }
    })();
  },
  postAsyncCall: (obj, data, callback, noHourGlass) => {
    if (token) {
      myApi.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
    const { setStateData, cookies, history, translateText, dispatch, loaderName, storeStateContext, handleOpen } = obj.context || {},
          payload = getPayloadData({ obj: obj.context, call: 'post', history, data, translateText });
    loaderName ? dispatch({ type: 'ADD_DATA', payload: { name: 'buttonLoader', data: {
      ...storeStateContext, [loaderName]: true,
    } } }) : handleOpen();
    (async () => {
      await apiCall({ obj, payload, callback, cookies, setStateData, history, noHourGlass });
    })()
      .catch(() => {});
  },
  getGeneratedDoc: (obj, data, callback) => {
    if (token) {
      myApi.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
    const { history, translateText, handleOpen, handleClose } = obj.context || {},
          payload = getPayloadData({ obj: obj.context, call: 'post', history, data, translateText });
    handleOpen();
    (async () => {
      // await Busy.wait();
      $$(':root').css('cursor', 'wait');
      await new Promise((resolve) => {
        setTimeout(function() {
          resolve((async () => {
            await myApi
              .post(obj.url, payload, { responseType: 'blob' })
              .then(async (response) => {
                try {
                  let filename = response.headers['content-disposition']?.split('filename=')[1];
                  if (callback) {
                    const res_data = response.headers['content-disposition']?.split('res_data=')[1];
                    filename = filename?.split(';')[0];
                    callback(res_data);
                  }
                  // handle blob
                  const file = new Blob([response.data], {
                    type: 'application/octet-stream',
                  });
                  const fileURL = URL.createObjectURL(file);
                  const a = document.createElement('a');
                  a.style = 'display: none';
                  //document.body.appendChild(a);
                  $$('body').append(a);
                  a.href = fileURL;
                  a.download = filename; // gives it a name via an a tag
                  a.target = '_blank';
                  a.rel = 'noreferrer noopener';
                  a.click();
                  $$('body').remove(a);
                  $$('*').css('cursor', '');
                  handleClose();
                }
                catch (err) {
                  const message = getValue('LangCode') === 'EN' || !getValue('LangCode') ? `File not found.` : `Archivo no encontrado.`;
                  handleCatchError(message, obj.context, obj.url);
                }
              })
              .catch(() => {
                const message = getValue('LangCode') === 'EN' || !getValue('LangCode') ? `File not found.` : `Archivo no encontrado.`;
                handleCatchError(message, obj.context, obj.url);
              });
          })(),
          );
        }, 1000);
      });
      // Busy.done();
    })()
      .catch(() => {
        handleClose();
      });
  },
  getDoc: (obj, filePathUrl, mode, callback) => {
    const { filePath = false } = filePathUrl || {},
          { state, handleOpen, handleClose } = obj?.context || {},
          { SessionID } = state || {},
          relative_file_path = filePath && `${filePath.replace(/\\/g, '/')}`,
          split_file_name = filePath && relative_file_path.split('/'),
          filename = filePath && split_file_name[split_file_name.length - 1],
          data = {
            filePath: relative_file_path,
            session: SessionID,
          };
    if (token) {
      myApi.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
    handleOpen();
    (async () => {
      // await Busy.wait();
      $$(':root').css('cursor', 'wait');
      await new Promise((resolve) => {
        setTimeout(function() {
          resolve((async () => {
            await myApi
              .post(obj.url, data, { responseType: 'blob' })
              .then(async (response) => {
                try {
                  const data = response.data;
                  let resText = await new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.addEventListener('abort', () => {
                      throw new Error('no file found');
                    });
                    reader.addEventListener('error', () => {
                      throw new Error('no file found');
                    });
                    reader.addEventListener('loadend', () => {
                      resolve(reader.result);
                    });
                    reader.readAsText(data);
                  });

                  if (resText) {
                    if (resText.indexOf('Login') > -1) {
                      // Same repair path as a normal response, and no unguarded [0]: this used to
                      // throw a TypeError that the catch below relabelled as 'File not found.'
                      const data = sanitizeJson(resText)?.data?.response_data?.[0] || {};
                      ApiWebMessage({
                        webMessage: data.WebMessage || data.ErrorMessage ||
                          'The server returned a login response instead of the requested file.',
                        Program: data.Program,
                        translateText: obj?.context?.translateText,
                        isErrorMessage: !!data.ErrorMessage,
                      });
                      $$('*').css('cursor', '');
                      handleClose();
                    }
                    else {
                      // handle blob
                      const file = new Blob([response.data], {
                        type: 'application/octet-stream',
                      });
                      const fileURL = URL.createObjectURL(file);
                      if (mode === 'view') {
                        callback(fileURL);
                        $$('*').css('cursor', '');
                        handleClose();
                        return;
                      }
                      const a = document.createElement('a');
                      a.style = 'display: none';
                      //document.body.appendChild(a);
                      $$('body').append(a);
                      a.href = fileURL;
                      a.download = filename; // gives it a name via an a tag
                      a.target = '_blank';
                      a.rel = 'noreferrer noopener';
                      a.click();
                      $$('body').remove(a);
                      $$('*').css('cursor', '');
                      handleClose();
                    }
                  }
                  else {
                    throw new Error('no file found');
                  }
                }
                catch (err) {
                  // ignore
                  const message = getValue('LangCode') === 'EN' || !getValue('LangCode') ? `File not found.` : `Archivo no encontrado.`;
                  handleCatchError(message, obj.context, obj.url);
                }
              })
              .catch(() => {
                const message = getValue('LangCode') === 'EN' || !getValue('LangCode') ? `File not found.` : `Archivo no encontrado.`;
                handleCatchError(message, obj.context, obj.url);
              });
          })(),
          );
        }, 1000);
      });
      // Busy.done();
    })()
      .catch(() => {
        handleClose();
      });
  },
};

export default withCookies(APICallManager);
